/* eslint-disable import/prefer-default-export */
import { Duration } from 'luxon'

export function formatDistance( start, end ) {
  return formatDuration( end - start )
}

export function formatDuration( duration, opts = { daysToHours : false, includeSeconds : true } ) {
  const settings = { milliseconds : 0 }
  if ( !opts.includeSeconds ) settings.seconds = 0

  let durationMS
  if ( !opts.includeSeconds && duration < 60000 ) durationMS = 60000 // round up to a min
  else durationMS = duration

  return Duration
    .fromMillis( durationMS )
    .rescale()
    .set( settings )
    .rescale()
    .toHuman( { unitDisplay : 'short', listStyle : 'narrow' } )
}

export function buildImageUrl( bucketUrl, imageName ) {
  
  const path = imageName.endsWith( '.jpg' ) ? imageName : `${imageName}.jpg`

  const url = `${bucketUrl}/${path}`

  return encodeURI( url )
}
